import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles } from './template.scss';
import { ImageState } from '../../../../ui/gzImageRepo/types';
import { FontSizes } from "../../../../types/common/types";

const liveSearchResultsGridTemplate = document.createElement('template');

liveSearchResultsGridTemplate.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
    <div class="content">
      <div class="grid" class="hidden">
        <gz-grid-view class="grid-view"></gz-grid-view>
      </div>

      <div id="not-started" class="hidden">
        <gz-image-repo class="mt-10" state="${ImageState.START}">
          <gz-title fontSize='${FontSizes.HEADING_4}' id="not-started-message"></gz-title>
          <gz-text id="not-started-additional-text" fontSize="14" lineHeight="2"></gz-text>
        </gz-image-repo>
      </div>

      <div id="no-results" class="hidden">
        <gz-image-repo class="mt-10" state="${ImageState.EMPTY}">
          <gz-title fontSize='${FontSizes.HEADING_4}' id="no-results-message"></gz-title>
        </gz-image-repo>
      </div>

      <div id="results-expired" class="hidden">
        <gz-image-repo class="mt-10" state="${ImageState.EMPTY}">
          <gz-title fontSize='${FontSizes.HEADING_4}' id="results-expired-message"></gz-title>
          <gz-text id="re-run-message" fontSize="14" lineHeight="2"></gz-text>
        </gz-image-repo>
      </div>

      <div id="in-progress" class="hidden">
        <gz-image-repo class="mt-10" state="${ImageState.EMPTY}">
          <gz-title fontSize='${FontSizes.HEADING_4}' id="in-progress-message"></gz-title>
        </gz-image-repo>
      </div>
    </div>
  </div>
`;

export default liveSearchResultsGridTemplate;
